export default "__VITE_ASSET__DDaOb9lU__"